import * as Sentry from "@sentry/react";
import type { Router } from "@tanstack/react-router";

function getTracesSampleRate(): number {
  const env = import.meta.env.VITE_ENVIRONMENT || "local";
  switch (env) {
    case "production":
      return 0.1;
    case "preview":
      return 0.5;
    default:
      return 1.0;
  }
}

function getReplaysSampleRate(): number {
  const env = import.meta.env.VITE_ENVIRONMENT || "local";
  switch (env) {
    case "production":
      return 0.1;
    case "preview":
      return 0.5;
    default:
      return 1.0;
  }
}

// biome-ignore lint/suspicious/noExplicitAny: TanStack Router generic params are irrelevant for Sentry integration
export function initSentry(router: Router<any, any, any, any>) {
  const environment = import.meta.env.VITE_ENVIRONMENT || "local";

  // Skip Sentry in local dev to avoid noise
  if (environment === "local") return;

  Sentry.init({
    dsn: "https://a55804d928bf79ba8b2718e4ad592c5d@o4511133905256448.ingest.us.sentry.io/4511134324228096",
    environment,
    integrations: [
      Sentry.tanstackRouterBrowserTracingIntegration(router),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: getTracesSampleRate(),
    replaysSessionSampleRate: getReplaysSampleRate(),
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event, hint) {
      const err = hint.originalException;

      // React Query CancelledError — normal when components unmount before query completes
      if (err && typeof err === "object" && "name" in err && (err as { name: string }).name === "CancelledError") {
        return null;
      }

      // ApiError with expected status codes — handled by UI (redirect to login, access denied)
      if (err && typeof err === "object" && "status" in err) {
        const status = (err as { status: number }).status;
        if (status === 401 || status === 403) return null;
      }

      // Network errors — transient, not actionable
      if (err instanceof TypeError) {
        const msg = err.message;
        if (msg === "Failed to fetch" || msg.includes("Importing a module script failed")) {
          return null;
        }
      }

      return event;
    },
  });
}
